module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": {
        path: '/' + _vm.langue
      }
    }
  }, [_c('a', {
    staticClass: "flag",
    class: {
      'active': _vm.isActiveLanguage()
    },
    on: {
      "click": function($event) {
        _vm.switchLanguage()
      }
    }
  }, [_c('img', {
    attrs: {
      "border": "0",
      "alt": "flag",
      "src": 'img/flag_' + _vm.langue + '.jpg'
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24d1377b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Langue.vue
// module id = 50
// module chunks = 0